'use strict';

exports.__esModule = true;
exports['default'] = clone;

var _validators = require('../../utils/validators');

function clone(source) {
  return function (target) {
    (0, _validators.validateClass)(target, 'clone');
    var originalPrototype = Object.assign({}, target.prototype);
    var originalTarget = Object.assign({}, target);
    Object.setPrototypeOf(target.prototype, source.prototype);
    Object.setPrototypeOf(target, source);
    Object.assign(target.prototype, originalPrototype);
    Object.assign(target, originalTarget);
  };
}


//////////////////
// WEBPACK FOOTER
// ./~/react-decoration/lib/decorators/components/clone.js
// module id = 544
// module chunks = 1